<template>
  <div>
    <MainLoading v-if="isLoading" />
    <MainError
      v-else-if="hasError"
      title="Não foi possivel carregar os proventos desse ano"
      description="Aguarde alguns minutos e tente novamente."
      @on-retry="getProfitAnnualData"
    />
    <div v-else class="annual-profit">
      <Heading :level="2" class="annual-profit__title">
        {{ year }}
      </Heading>
      <HeadingDisplay
        title=""
        size="extra-small"
        head="Proventos recebidos"
        class="annual-profit__heading-display"
      >
        <template #title-component>
          <Money>{{ profitData?.years[0].annual.formatted }}</Money>
        </template>
      </HeadingDisplay>
      <Grid
        v-if="profitData?.years[0].monthlies"
        :columns="[2, 2]"
        :gutter="32"
        class="annual-profit__grid"
      >
        <AnnualProfitRow
          v-for="(profit, index) in profitData?.years[0].monthlies"
          :key="index"
          :profit-data="profit"
          :portfolio-id="portfolioId"
          :year="year"
          :has-divider="index !== 0 && index !== 6"
        />
      </Grid>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Heading, HeadingDisplay, Grid } from '@warrenbrasil/nebraska-web';
import { MainError } from '@/modules/trade/components/MainError';
import { MainLoading } from '@/modules/trade/components/MainLoading';
import { Money } from '@/modules/common/components/MoneyV2';
import { computed, onMounted, ref } from 'vue';
import {
  getAnnualProfit,
  ProfitAnnualData
} from '@/modules/wealth/services/portfolio';
import { AnnualProfitRow } from '../AnnualProfitRow';

interface Props {
  portfolioId: string;
}
const props = defineProps<Props>();

const isLoading = ref(false);
const hasError = ref(false);
const profitData = ref<ProfitAnnualData | null>(null);
const year = computed(() => String(profitData.value?.years[0].year));

const getProfitAnnualData = async () => {
  isLoading.value = true;
  hasError.value = false;

  try {
    profitData.value = await getAnnualProfit(props.portfolioId);
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};
onMounted(getProfitAnnualData);
</script>

<style lang="less" scoped>
.annual-profit {
  margin-top: @size-spacing-x1200;

  &__title {
    margin-bottom: @size-spacing-x500;
  }

  &__heading-display {
    padding-bottom: @size-spacing-x500;
    border-bottom: @size-border-x400 @divider-primary solid;
  }

  &__grid {
    grid-template-rows: repeat(6, 1fr);
    grid-auto-flow: column;

    @media screen and (max-width: 768px) {
      grid-auto-flow: row !important;
    }
  }
}
</style>
